<template>
    <v-app color="white">
        <!-- Layout component -->
        <component :is="currentLayout">
            <!-- <transition name="fade" mode="out-in"> -->
            <router-view />
            <!-- </transition> -->
        </component>
        <v-dialog persistent v-model="signInForm" width="600">
            <v-card flat>
                <v-card-title class="d-flex justify-space-between">
                    <p class="h3 mb-0">Sign In</p>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-3 pb-0">
                    <v-alert
                        class="word-break ma-3"
                        type="error"
                        v-if="!!errorMessage"
                        v-html="errorMessage"
                    />
                    <v-alert
                        class="word-break ma-3"
                        type="success"
                        v-if="!!signInMessage"
                        >{{ signInMessage }}</v-alert
                    >
                    <v-form ref="loginForm">
                        <v-col class="">
                            <v-text-field
                                label="Email Address"
                                v-model="email"
                                variant="outlined"
                                :rules="emailRules"
                                ref="email"
                            ></v-text-field>
                        </v-col>
                        <v-col class="pt-2">
                            <v-text-field
                                type="password"
                                label="Enter password"
                                v-model="password"
                                variant="outlined"
                                :rules="passwordRules"
                                ref="password"
                            ></v-text-field>
                        </v-col>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-row no-gutters>
                        <v-col cols="12" class="px-7">
                            <v-btn
                                color="primary"
                                block
                                variant="flat"
                                size="large"
                                @click="signIn()"
                            >
                                <v-progress-circular
                                    :size="20"
                                    color="white"
                                    indeterminate
                                    v-if="isAuthAccountInProgress"
                                ></v-progress-circular>
                                &nbsp;SIGN IN
                            </v-btn>
                        </v-col>
                        <!--
                        <v-col cols="12" class="py-5" align="center">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="goToForgetPassword()"
                                >Forgot Your Password?</span
                            > </v-col
                        >-->
                        <v-col cols="12" class="py-5" align="center">
                            <span
                                class="text-decoration-none cursor-pointer text-primary"
                                @click="goToHomePage()"
                                >Go Home</span
                            >
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import defaultLayout from "@/components/layout/DefaultLayout.vue";
import builderLayout from "@/components/layout/BuilderLayout.vue";
import designerLayout from "@/components/layout/DesignerLayout.vue";
const { mapFields: mapFieldsAuth } = createHelpers({
    getterType: "auth/getField",
    mutationType: "auth/updateField",
});
import { createHelpers } from "vuex-map-fields";
const storeFrontUrl = import.meta.env.VITE_APP_CRANE_DAILY_URL;

export default {
    components: {
        defaultLayout,
        designerLayout,
        builderLayout,
    },
    name: "App",
    created() {
        console.info("Studio version - ", import.meta.env.VITE_BUILD_VERSION);
    },
    data: () => ({
        emailRules: [
            (v) => !!v || "E-mail is required",
            (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        passwordRules: [
            (v) => !!v || "Password is required",
            (v) =>
                (v && v.length >= 8) ||
                "Password must be at least 8 characters",
        ],
    }),

    computed: {
        currentLayout: function () {
            const layout = this.$route.meta.layout || "default";

            return layout + "Layout";
        },
        ...mapFieldsAuth([
            "one",
            "one.email",
            "one.password",
            "errorMessage",
            "signInMessage",
        ]),
        signInForm: function () {
            return this.$store.state.auth.showLoginDialog;
        },
        isAuthAccountInProgress() {
            const state = this.$store.state;
            return state.auth.inProgress || state.accountOne.inProgress;
        },
    },
    methods: {
        closeSignInForm() {
            this.signInForm = false;
            this.$store.dispatch("auth/changeRedirectFlag", true);
        },

        async signIn() {
            let validate = await this.$refs.loginForm.validate();

            if (validate?.valid) {
                this.$store.dispatch("auth/changeRedirectFlag", false);

                let response = await this.$store.dispatch("auth/login");

                if (response) {
                    // this.$store.dispatch("auth/changeRedirectFlag", true);
                    this.$store.dispatch("auth/closeLoginPopup");
                    // reload current page after login
                    window.location.reload();
                }
            }
        },

        goToForgetPassword() {
            window.open(`/gate/forgot-password`, "_self");
        },
        goToHomePage() {
            localStorage.removeItem("cr_checkOutTab");
            this.$store.dispatch("auth/logout");
            try {
                window.DD_RUM.onReady(function () {
                    window.DD_RUM.clearUser();
                });
            } catch (error) {
                console.error("error in dd user clear", error);
            }
            window.open(`${storeFrontUrl}/`, "_self");
        },
    },
};
</script>
<style src="@/styles/_app.scss" lang="scss" />
